// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(min-width:992px){.content-display__main{grid-column:3/span 8;padding:80px 0}}@media(min-width:768px)and (max-width:991px){.content-display__main{grid-column:2/span 10;padding:60px 0}}@media(max-width:767px){.content-display__main{grid-column:span 12;padding:40px 0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
